import S from "./Icon.module.scss";
import { IconNames } from "../../../enums/icons.enums";
import { SvgIcon } from "../../Atoms/SvgIcon/SvgIcon";
import { cn } from "@shared/helpers/classNames.helper";

export interface IconProps {
    text?: string;
    iconName: IconNames;
    className?: string;
}

export const Icon = ({ text, iconName, className }: IconProps) => {
    return (
        <div className={cn(S.icon, className)}>
            <div className={S.iconWrapper}>
                <SvgIcon iconName={iconName} />
            </div>
            <div className={S.iconText}>
                <span className={S.text}>{text}</span>
            </div>
        </div>
    );
};
